<div class="example-container">
    <div class="example-loading-shadee">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoadingRowResults || isLoadingSupplierResults"></mat-progress-bar>
    </div>

    <div class="example-table-container">
        <div class="kp-label-overview-settings">
            <mat-form-field [class.field-with-label]="true">
                <mat-label>Kweker</mat-label>
                <input #supplierInput type="text" placeholder="Selecteer een kweker..." aria-label="Kweker" matInput
                       [formControl]="control" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option (onSelectionChange)="supplierInput.value != undefined && onEnter($event)"
                                *ngFor="let option of filteredSuppliers | async" [value]="option.name">
                        {{option.name}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field [class.field-with-label]="true">
                <mat-label>Leverdatum</mat-label>
                <input matInput [(ngModel)]="filters.leverdatum" [matDatepicker]="leverdatumPicker" (ngModelChange)="refresh()">
                <mat-datepicker-toggle matIconSuffix [for]="leverdatumPicker"></mat-datepicker-toggle>
                <mat-datepicker #leverdatumPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field [class.field-with-label]="true">
                <mat-label>Levertijdstip</mat-label>
                <input matInput type="time" [(ngModel)]="filters.levertijdstip" (blur)="refresh()">
                <mat-icon matSuffix>schedule</mat-icon>
            </mat-form-field>

            <mat-form-field [class.field-with-label]="true">
                <mat-label>Potmaat</mat-label>
                <input #potmaatInput type="text" placeholder="Selecteer een potmaat..." aria-label="Potmaat" matInput
                       [formControl]="potmaatcontrol" [matAutocomplete]="autoPotmaat">
                <mat-autocomplete #autoPotmaat="matAutocomplete">
                    <mat-option (onSelectionChange)="onEnterPotmaat($event)"
                                *ngFor="let option of filteredPotmaten | async" [value]="option">
                        {{option}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field [class.field-with-label]="true">
                <mat-label>Afmeting sticker</mat-label>
                <input #afmetingStickerInput type="text" placeholder="Selecteer een afmeting..." aria-label="Afmeting sticker" matInput
                       [formControl]="afmetingStickercontrol" [matAutocomplete]="autoAfmetingSticker">
                <mat-autocomplete #autoAfmetingSticker="matAutocomplete">
                    <mat-option (onSelectionChange)="onEnterAfmetingSticker($event)"
                                *ngFor="let option of filteredAfmetingStickers | async" [value]="option">
                        {{option}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field [class.field-with-label]="true">
                <mat-label>Kwekerartikelnr</mat-label>
                <input #supplierAssignedIdInput type="text" placeholder="Selecteer een kwekerartikelnr..." aria-label="Kwekerartikelnr" matInput
                       [formControl]="supplierAssignedIdcontrol" [matAutocomplete]="autoKwekerArtikelNr">
                <mat-autocomplete #autoKwekerArtikelNr="matAutocomplete">
                    <mat-option (onSelectionChange)="onEnterSupplierAssignedId($event)"
                                *ngFor="let option of filteredSupplierAssignedIds | async" [value]="option">
                        {{option}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field [class.field-with-label]="true">
                <mat-label>Zoeken</mat-label>
                <input
                        matInput
                        type="text"
                        [(ngModel)]="filters.searchTerm"
                        (ngModelChange)="onSearchTermInput($event)"
                        [ngModelOptions]="{standalone: true}"
                        #searchTermInput="ngModel"
                >
                <button mat-icon-button *ngIf="!filters.searchTermIsEmpty" matSuffix aria-label="Clear" (click)="doResetSearchTerm()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>



            <button mat-icon-button aria-label="Reset filters" (click)="doResetFilters(true)">
                <mat-icon>settings_backup_restore</mat-icon>
            </button>
        </div>

        <div class="d-flex flex-row justify-content-end mx-3">

            <button mat-raised-button color="primary" (click)="printUnPrintedLabels()"
                    [disabled]="!unprintedSelection || unprintedSelection.length == 0" *ngIf="selectedTabIndex==0">
                Labels printen
            </button>
            <ng-container *ngIf="selectedTabIndex==1">
                <button mat-raised-button color="primary" (click)="markAsUnprinted()"
                        [disabled]="!printedSelection || printedSelection.length == 0" class="mx-2" title="De geselecteerde labels worden gemarkeerd als niet geprinte labels">
                    Markeren als 'niet-geprint'
                </button>
                <button mat-raised-button color="primary" (click)="printPrintedLabels()"
                        [disabled]="!printedSelection || printedSelection.length == 0">
                    Labels printen
                </button>
            </ng-container>
        </div>
        <mat-tab-group (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Openstaand">
                <ng-template matTabContent>
                    <div class="pt-2">
                        <app-labels-table
                                [data]="dataPrinted"
                                [pageIndex]="printedPageIndex"
                                [pageSize]="printedPageSize"
                                [totalCount]="printedTotalCount"
                                (onSelectionChange)="onSelectionChangeUnprinted($event)"
                                (pageChange)="onPrintedPageChanged($event)">
                        </app-labels-table>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab label="Geprint">
                <ng-template matTabContent>
                    <div class="pt-2">
                        <app-labels-table
                                [data]="dataUnPrinted"
                                [pageIndex]="unprintedPageIndex"
                                [pageSize]="unprintedPageSize"
                                [totalCount]="unprintedTotalCount"
                                (onSelectionChange)="onSelectionChangePrinted($event)"
                                (pageChange)="onUnprintedPageChanged($event)">
                        </app-labels-table>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

    </div>
</div>